import type { consoleBffAuth } from "@kintone-storage/openapi-types";
import { apiClient, ApiError, consoleBffRequestUrl } from "./client";

export type InquiryPrivacyPolicy =
  consoleBffAuth.components["schemas"]["InquiryPrivacyPolicyDescriptor"];
export type InquiryCreateRequest =
  consoleBffAuth.components["schemas"]["InquiryCreateRequest"];
export type InquiryCreateResponse =
  consoleBffAuth.components["schemas"]["InquiryCreateResponse"];

export async function fetchInquiryPrivacyPolicy(): Promise<InquiryPrivacyPolicy> {
  const response = await fetch(consoleBffRequestUrl("/console-bff/inquiries/privacy-policy"), {
    credentials: "include",
    cache: "no-store",
  });
  if (!response.ok) throw await toApiError(response, "個人情報の取扱い文書を取得できませんでした。");
  return await response.json() as InquiryPrivacyPolicy;
}

export async function submitInquiry(
  request: InquiryCreateRequest,
  idempotencyKey: string,
): Promise<InquiryCreateResponse> {
  if (request.sourceKind === "logged_in") {
    return apiClient<InquiryCreateResponse>("/console-bff/inquiries", {
      method: "POST",
      headers: { "Idempotency-Key": idempotencyKey },
      body: JSON.stringify(request),
    });
  }
  const response = await fetch(consoleBffRequestUrl("/console-bff/inquiries"), {
    method: "POST",
    credentials: "include",
    headers: {
      "content-type": "application/json",
      "Idempotency-Key": idempotencyKey,
    },
    body: JSON.stringify(request),
  });
  if (!response.ok) throw await toApiError(response, "問い合わせを送信できませんでした。");
  return await response.json() as InquiryCreateResponse;
}

async function toApiError(response: Response, fallback: string) {
  const body = await response.json().catch(() => ({})) as {
    code?: string;
    message?: string;
    requestId?: string;
    retryable?: boolean;
    diagnostic?: unknown;
  };
  const retryAfterValue = response.headers.get("retry-after");
  const retryAfter = retryAfterValue && /^\d+$/.test(retryAfterValue)
    ? Number(retryAfterValue)
    : undefined;
  return new ApiError(
    response.status,
    body.code ?? "UNKNOWN",
    body.message ?? fallback,
    body.requestId,
    body.diagnostic === undefined ? undefined : { diagnostic: body.diagnostic },
    body.retryable,
    retryAfter,
  );
}
